import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './SegmentedSelectionLite.module.css';

const bindClasses = classNameBind.bind(styles);

const SegmentedSelectionLite = ({ value, onChange, items, dataId = 'SegmentedSelectionLite' }) => (
  <div className={bindClasses('wrapper')} data-ppuc-id={dataId}>
    <div
      className={bindClasses('selected-marker')}
      style={{ left: `${items.findIndex(item => item.value === value) * 28 + 1}px` }}
      data-ppuc-id={`${dataId}.marker`}
    />
    {
      items.map(item => (
        <div
          className={bindClasses('item', { selected: item.value === value })}
          key={item.value}
          onClick={() => onChange(item.value)}
          role="button"
          tabIndex={0}
          data-ppuc-id={`${dataId}.item-${item.value}`}
        >
          {item.value}
        </div>
      ))
    }
  </div>
);

export default SegmentedSelectionLite;
